import moment from "moment";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import MonitoringReportFileContentModel from '../../../models/monitoring-report/file-level.model';
import ViewBase from "../../view-base.view";

export default function SuccessfulFileDetails() {

  ViewBase.call(this);

  const STATUS_FILE_DOWNLOAD = {
    SUCCESS: 0,
    NEW_UPLOAD: 1,
    FAIL: 2
  }

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0,
  };

  const DEFAULT_FILTERS = Object.freeze({
    fileName: '',
    status: '',
  });

  let pagination = structuredClone(DEFAULT_PAGINATION);

  let fileNames = [];
  let status = [];
  let tableData = []

  let filters = structuredClone(DEFAULT_FILTERS);
  let currentFilters = structuredClone(DEFAULT_FILTERS);

  const handleSearch = (data) => {
    this.showLoading();

    currentFilters = structuredClone(filters)
    pagination.pageIndex = 1;

    const params = {
      sortBy: '',
      orderBy: '',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      fromDate: data.fromDate,
      toDate: data.toDate,
      clientCode: data.customerCode,
      fileType: data.fileCode,
      fileName: currentFilters.fileName,
      status: currentFilters.status
    }

    MonitoringReportFileContentModel.intfFileLevelReportDetail(params)
      .then(result => {
        tableData = result.datas.data
        pagination.pageIndex = result.datas.pageIndex
        pagination.pageSize = result.datas.pageSize
        pagination.totalItems = result.datas.total
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() =>
        this.hideLoading()
      )
  }

  const handleFirstLoadDialog = (data) => {
    this.showLoading();

    const params = {
      sortBy: '',
      orderBy: '',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      fromDate: data.fromDate,
      toDate: data.toDate,
      clientCode: data.customerCode,
      fileType: data.fileCode,
      fileName: '',
      status: ''
    }

    MonitoringReportFileContentModel.intfFileLevelReportDetail(params)
      .then(result => {
        fileNames = result.filenames.map(item => ({
          code: item.fileName,
          name: item.fileName
        }));
        status = result.status.map(item => ({
          code: item.statusCode,
          name: item.statusDesc
        }))
        tableData = result.datas.data
        pagination.pageIndex = result.datas.pageIndex
        pagination.pageSize = result.datas.pageSize
        pagination.totalItems = result.datas.total
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() =>
        this.hideLoading()
      )
  }

  const handlePageChange = (attrs, pageIndex) => {
    this.showLoading();

    pagination.pageIndex = pageIndex;

    const params = {
      sortBy: '',
      orderBy: '',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      fromDate: attrs.fromDate,
      toDate: attrs.toDate,
      clientCode: attrs.customerCode,
      fileType: attrs.fileCode,
      fileName: currentFilters.fileName,
      status: currentFilters.status
    }

    MonitoringReportFileContentModel.intfFileLevelReportDetail(params)
      .then(result => {
        tableData = result.datas.data
        pagination.pageIndex = result.datas.pageIndex
        pagination.pageSize = result.datas.pageSize
        pagination.totalItems = result.datas.total
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() =>
        this.hideLoading()
      )
  }

  const handlePageSizeChange = (attrs, pageIndex, pageSize) => {
    this.showLoading();

    pagination.pageSize = pageSize;
    pagination.pageIndex = pageIndex;

    const params = {
      sortBy: '',
      orderBy: '',
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      fromDate: attrs.fromDate,
      toDate: attrs.toDate,
      clientCode: attrs.customerCode,
      fileType: attrs.fileCode,
      fileName: currentFilters.fileName,
      status: currentFilters.status
    }

    MonitoringReportFileContentModel.intfFileLevelReportDetail(params)
      .then(result => {
        tableData = result.datas.data
        pagination.pageIndex = result.datas.pageIndex
        pagination.pageSize = result.datas.pageSize
        pagination.totalItems = result.datas.total
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() =>
        this.hideLoading()
      )
  }

  const handleDownloadBreakdown = (data) => {
    const params = {
      clientCode: data.customerCode,
      fromDate: data.fromDate,
      toDate: data.toDate,
      fileType: data.fileCode,
      fileName: currentFilters.fileName,
      status: currentFilters.status
    }
    MonitoringReportFileContentModel.intfFileLevelReportDetailExport(params, `INTF-FileLevel-DetailBreakDown_${moment().format('YYYYMMDDHHmm')}`)
  }

  const handleClear = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  }

  const handleFileDownload = (data, status) => {
    const params =
    {
      fromDate: data.fromDate,
      toDate: data.toDate,
      clientCode: data.customerCode,
      fileType: data.fileCode,
      status
    }
    MonitoringReportFileContentModel.intfFileLevelFileDownload(params, 'INTF-FileLevel-FileDownload')
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleStatusChange = (item) => {
    filters.status = item
  }

  const handleFileNameChange = (item) => {
    filters.fileName = item
  }

  return {
    oninit: (vnode) => {
      handleFirstLoadDialog(vnode.attrs.data)
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-12',
            m('.d-flex.justify-content-between.mb-2',
              m("button.btn.btn-primary",
                {
                  onclick: () => { handleFileDownload(vnode.attrs.data, STATUS_FILE_DOWNLOAD.SUCCESS) },
                },
                m("i.bi.bi-file-earmark-arrow-down-fill"),
                this.getText("LT00001037", "Download Original Files")
              ),
              m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
                m('i.bi.bi-filter'),
                this.getText("LT00000232", "Filter"),
              ),
            ),

            // Search section
            m('#search-section.collapse',
              m('.card.mb-3',
                m('.card-body',
                  m('.row.g-4.mb-1',
                    m('.col.col-md-6',
                      m('.row.g-4',
                        m('.col.font-weight-bold', this.getText("LT00001026", 'Customer Code')),
                        m('.col', vnode.attrs.data.customerCode)
                      )
                    ),
                    m('.col.col-md-6',
                      m('.row.g-4',
                        m('.col.font-weight-bold', this.getText("LT00001027", 'Customer Name')),
                        m('.col', vnode.attrs.data.customerName)
                      )
                    )
                  ),
                  m('.row.g-4.mb-1',
                    m('.col.col-md-6',
                      m('.row.g-4',
                        m('.col.font-weight-bold', this.getText('LT00001039', 'From Date')),
                        m('.col', vnode.attrs.data.fromDate)
                      )
                    ),
                    m('.col.col-md-6',
                      m('.row.g-4',
                        m('.col.font-weight-bold', this.getText('LT00001041', 'To Date')),
                        m('.col', vnode.attrs.data.toDate)
                      )
                    )
                  ),
                  m('.row.g-4.mb-3',
                    m('.col.col-md-6',
                      m('.row.g-4',
                        m('.col.font-weight-bold', this.getText('LT00008055', 'File Type')),
                        m('.col', vnode.attrs.data.fileType)
                      )
                    )
                  ),
                  m('.row.g-4',
                    m('.col-md-6',
                      m(
                        'label.form-label.font-weight-bold[for="fileName"]',
                        this.getText("LT00000883", "File Name")
                      ),
                      m(SingleSelectComponent, {
                        id: "fileName",
                        items: fileNames,
                        keyOnly: true,
                        allowEmpty: true,
                        filterable: false,
                        selectedItem: filters.fileName,
                        onSelect: handleFileNameChange,
                      })
                    ),
                    m('.col-md-6',
                      m('label.form-label.font-weight-bold[for="status"]',
                        this.getText("LT00000015", "Status")
                      ),
                      m(SingleSelectComponent, {
                        id: "status",
                        items: status,
                        keyOnly: true,
                        allowEmpty: true,
                        filterable: false,
                        selectedItem: filters.status,
                        onSelect: handleStatusChange,
                      })
                    ),
                    m(".col-12.d-flex.justify-content-end.gap-2",
                      m("button.btn.btn-primary",
                        {
                          onclick: () => handleSearch(vnode.attrs.data)
                        },
                        this.getText("LT00000001", "Search")
                      ),
                      m("button.btn.btn-white",
                        {
                          type: "button",
                          onclick: handleClear,
                        },
                        this.getText("LT00000031", "Clear")
                      )
                    )
                  )
                )
              )
            ),

            // Table section
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m("button.btn.btn-primary",
                    {
                      onclick: () => {
                        handleDownloadBreakdown(vnode.attrs.data)
                      },
                    },
                    m("i.bi.bi-file-earmark-arrow-down-fill"),
                    this.getText("LT00001042", "Download Breakdown")
                  ),
                ),
                m('.row',
                  m(".col-12",
                    m(".table-responsive",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle",
                              [
                                m("th", { "scope": "col" }, this.getText("LT00001043", "From Branch Code")),
                                m("th", { "scope": "col" }, this.getText("LT00000918", "Sales Date")),
                                m("th", { "scope": "col" }, this.getText("LT00000717", "Model")),
                                m("th", { "scope": "col" }, this.getText("LT00001044", "Sales Qty")),
                                m("th", { "scope": "col" }, this.getText("LT00001045", "IMEI/Serial Number")),
                                m("th", { "scope": "col" }, this.getText("LT00001046", "To Branch Code")),
                                m("th", { "scope": "col" }, this.getText("LT00000015", "Status")),
                                m("th", { "scope": "col" }, this.getText("LT00000883", "File Name"))
                              ])
                          ),
                          m("tbody",
                            tableData.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "9" }, this.getText("EM00000141", "No records found."))
                            ),
                            tableData.map(item =>
                              [
                                m("tr",
                                  [
                                    m("td", item.fromBranchCode),
                                    m("td", item.salesDate),
                                    m("td", item.model),
                                    m("td", item.salesQty),
                                    m("td", item.imeiSerialNumber),
                                    m("td", item.toBranchCode),
                                    m("td", item.status),
                                    m("td", item.fileName),
                                  ])
                              ]),
                          )
                        ])
                    )
                  ),
                  m(".col-12",
                    m(paginationComponent, {
                      currentPage: pagination.pageIndex,
                      pageSize: pagination.pageSize,
                      totalItems: pagination.totalItems,
                      onPageChanged: (pageIndex) => {
                        handlePageChange(vnode.attrs.data, pageIndex)
                      },
                      onPageSizeChanged: (pageIndex, pageSize) => {
                        handlePageSizeChange(vnode.attrs.data, pageIndex, pageSize)
                      },
                    })
                  )
                )
              )
            )
          ),
        ),
        this.getBaseViews()
      ]
    }
  }
}
